import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=5c436ea1&"
import script from "./CircularLoader.vue?vue&type=script&lang=ts&"
export * from "./CircularLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CircularLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
